import { Link } from 'react-router-dom';

export default function Forbidden() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-white px-6 py-24 pt-[120px]">
      <div className="max-w-md w-full text-center space-y-6 bg-slate-50 p-8 md:p-10 rounded-2xl border border-slate-100/80">
        <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-red-50 text-red-500 mx-auto">
          <i className="fa-regular fa-shield-exclamation text-3xl" />
        </div>
        <div className="space-y-2">
          <h1 className="text-3xl font-extrabold tracking-tight text-primary font-display">403 - Access Denied</h1>
          <p className="text-slate-500 text-sm leading-relaxed">
            You do not have permission to access this page. If you believe this is an error, please contact our support team.
          </p>
        </div>
        <div className="pt-4 flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/"
            className="py-3 px-6 rounded-xl bg-primary text-white font-semibold hover:bg-primary-light transition-all duration-200 text-sm shadow-sm"
          >
            Go to Homepage
          </Link>
          <Link
            to="/contact"
            className="py-3 px-6 rounded-xl bg-slate-50 text-primary font-semibold hover:bg-slate-100 transition-all duration-200 text-sm border border-slate-100"
          >
            Contact Us
          </Link>
        </div>
      </div>
    </div>
  );
}
